import { isUserLoggedIn } from '@/auth/utils'

export default {
  data() {
    return {
      pendingAction: null
    }
  },
  methods: {
    requireAuth(callback, actionName = 'action') {
      const isLoggedIn = isUserLoggedIn()
      console.log(
        `[AuthCheck] User login status: ${
          isLoggedIn ? 'LOGGED IN' : 'NOT LOGGED IN'
        } for action: ${actionName}`
      )

      if (!isLoggedIn) {
        console.log(
          `[AuthCheck] Storing pending action: ${actionName} and showing login modal`
        )
        this.pendingAction = {
          callback,
          name: actionName
        }
        this.$emit('show-login-modal')
        return false
      }

      console.log(
        `[AuthCheck] User is logged in, executing action: ${actionName}`
      )
      if (typeof callback === 'function') {
        callback()
      }
      return true
    },

    executeStoredAction() {
      if (
        this.pendingAction &&
        typeof this.pendingAction.callback === 'function'
      ) {
        console.log(
          `[AuthCheck] Login successful! Executing stored action: ${this.pendingAction.name}`
        )
        this.pendingAction.callback()
        this.pendingAction = null
      } else {
        console.log(
          `[AuthCheck] Login successful but no pending action to execute`
        )
      }
    },

    clearStoredAction() {
      this.pendingAction = null
    },

    isUserLoggedIn() {
      return isUserLoggedIn()
    }
  },

  created() {
    this.$on('login-success', this.executeStoredAction)
  },

  beforeDestroy() {
    this.$off('login-success', this.executeStoredAction)
  }
}
